import * as Vue from 'vue/dist/vue.esm-bundler.js';

window.Vue = Vue;